import React from 'react';
import '../../styles/about/aboutPage.scss';
import aboutCollageImage from '../../assets/images/about_collage.png';
import visionImage from '../../assets/images/our_vision.png';
import innovationPlayerImage from '../../assets/images/player_imag.png';
import scoreIcon from '../../assets/images/image 467.svg';
import streamIcon from '../../assets/images/playbutton.svg';
import learnIcon from '../../assets/images/learrn.svg';

const aboutHeroData = {
  badge: 'ABOUT US',
  titleStart: 'Discover our mission',
  titleMiddle: 'and values in',
  brand: 'CricCenter',
  description:
    'At criccenter.com, we believe every cricketer has the potential to achieve greatness, no matter their skill level. We’re not just an app — we’re your dedicated partner in the journey of growth and cricketing excellence.',
};

const aboutValuesData = {
  titleLine1: 'From First Ball to Final Victory',
  titleLine2Start: 'We’re With You Every Step',
  titleLine2Accent: '',
  description:
    'At criccenter.com, we believe every cricketer has the potential to achieve greatness, no matter their skill level. We’re not just an app — we’re your dedicated partner in the journey of growth and cricketing excellence.',
  points: [
    {
      title: 'Our Belief',
      text: 'At criccenter.com, we believe cricket has the power to unite, inspire, and uplift people around the world.',
    },
    {
      title: 'Our Mission',
      text: 'We aim to build a global platform where every cricket player — from passionate beginners to seasoned pros — can thrive and grow.',
    },
    {
      title: 'Our Commitment',
      text: 'We are dedicated to offering the tools, resources, and support you need to evolve into a better, more skilled cricketer.',
    },
  ],
};

const aboutVisionData = {
  badge: 'OUR VISION',
  title: 'The way we do things',
  description:
    'Envision a future where the cricketing community is a boundless network of inspiration and collaboration. Regardless of your current level, we see you as an integral part of this dynamic and interconnected tapestry. Through our app, we aspire to be the catalyst that fuels your journey of continuous improvement, camaraderie, and success.',
};

const aboutInnovationData = {
  titleStart: 'Player-Centric',
  titleAccent: 'Innovation',
  description:
    'Designed by International Cricket Players: Your journey is our inspiration. criccenter.com is not just an app; it is a cricketing odyssey meticulously crafted by an international cricket player. Every feature is born from the belief that each player, at every level, deserves tools tailored to their unique journey.'
};

const getInGameData = {
  titleStart: 'Get in the',
  titleAccent: 'Game',
  description:
    '"Get in the Game" with criccenter.com -- a rallying call to embrace your passion for cricket. Every aspect of our app is thoughtfully designed to elevate your cricketing experience, giving you the tools to score, stream, and learn like never before.',
  highlights: [
    {
      icon: scoreIcon,
      title: 'Score',
      text: 'Stay ahead with real-time scoring tools',
    },
    {
      icon: streamIcon,
      title: 'Stream',
      text: 'Watch and relive the action anytime, anywhere.',
    },
    {
      icon: learnIcon,
      title: 'Learn',
      text: 'Gain insights, tips, and training to level up your game.',
    },
  ],
  closingTitleStart: 'Advancing',
  closingTitleAccent: 'Cricket Together',
  closingDescription:
    "Whether you're standing on the fields of the USA, the cricket grounds of Canada, or any other cricket-playing nation, cricCenter.com is not just an app; it's your steadfast companion and ally in every format of the game.",
};

const communityCtaData = {
  title: 'Join Our Global Cricketing Community',
  description:
    "CricCenter.com is a vibrant global community united by a shared love for cricket, celebrating every player's journey and spirit.",
  buttonLabel: 'Connect ->',
};

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-page-content">
        <div style={{ width: '100%', height: '90px', backgroundColor: 'black', }}></div>
        <section className="about-hero-section">
          <span className="about-badge">{aboutHeroData.badge}</span>

          <h1 className="about-title">
            <span>{aboutHeroData.titleStart}</span>
            <br />
            <span>
              {aboutHeroData.titleMiddle}{' '}
              <em>{aboutHeroData.brand}</em>
            </span>
          </h1>

          <p className="about-description">{aboutHeroData.description}</p>

          <div className="about-collage">
            <img src={aboutCollageImage} alt="Criccenter mission team collaboration" />
          </div>
        </section>

        <section className="about-values-section">
          <h2 className="about-values-title">
            <span>{aboutValuesData.titleLine1}</span>
            <br />
            <span>
              <em>{aboutValuesData.titleLine2Start}</em>
            </span>
          </h2>

          <p className="about-values-description">{aboutValuesData.description}</p>

          <div className="about-values-timeline">
            <div className="timeline-rail" aria-hidden>
              <span className="timeline-dot" />
              <span className="timeline-dot" />
              <span className="timeline-dot" />
            </div>

            <div className="timeline-content">
              {aboutValuesData.points.map((point) => (
                <article key={point.title} className="timeline-item">
                  <h3>{point.title}</h3>
                  <p>{point.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="about-vision-section">
          <div className="vision-split-panel">
            <div className="vision-image-wrap">
              <img src={visionImage} alt="Cricket vision" />
              <article className="vision-content">
                <span className="vision-badge">{aboutVisionData.badge}</span>
                <h2>{aboutVisionData.title}</h2>
                <p>{aboutVisionData.description}</p>
              </article>
            </div>
          </div>

          <div className="innovation-block">
            <div className="innovation-heading-box">
              <h3>
                <span>{aboutInnovationData.titleStart}</span>{' '}
                <em>{aboutInnovationData.titleAccent}</em>
              </h3>
              <p>{aboutInnovationData.description}</p>
            </div>

            <div className="innovation-player-wrap">
              <img src={innovationPlayerImage} alt="Player centric innovation" />
            </div>
          </div>
        </section>

        <section className="about-get-in-game-section">
          <h2 className="get-in-game-title">
            <span>{getInGameData.titleStart}</span>{' '}
            <em>{getInGameData.titleAccent}</em>
          </h2>

          <p className="get-in-game-description">{getInGameData.description}</p>

          <div className="get-in-game-highlights">
            {getInGameData.highlights.map((item) => (
              <article key={item.title} className="get-in-game-highlight-item">
                <img src={item.icon} alt={item.title} />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>

          <h3 className="get-in-game-closing-title">
            <span>{getInGameData.closingTitleStart}</span>{' '}
            <em>{getInGameData.closingTitleAccent}</em>
          </h3>

          <p className="get-in-game-closing-description">
            {getInGameData.closingDescription}
          </p>
        </section>

        <section className="about-community-cta-section">
          <div className="community-cta-card">
            <h2>{communityCtaData.title}</h2>
            <p>{communityCtaData.description}</p>
            <button type="button">{communityCtaData.buttonLabel}</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
